export default {
  assignedChats: state => {
    return state.assignedChats;
  },

  isChatAssigned: (state, getters, rootState, rootGetters) => {
    const activeChat = rootGetters["whatsappChat/activeChat"];
    const index = getters.assignedChats.findIndex(
      x => x.assignedNumber === activeChat.phone
    );
    if (
      index !== -1
      // && getters.assignedChats[index].assignedTo.id === rootState.user.userMongoID
    ) {
      return true;
    } else {
      return false;
    }
  },

  isChatAssignedToSelf: (state, getters, rootState, rootGetters) => {
    const activeChat = rootGetters["whatsappChat/activeChat"];
    const index = getters.assignedChats.findIndex(
      x => x.assignedNumber === activeChat.phone
    );
    if (
      index !== -1 &&
      getters.assignedChats[index].assignedTo.id === rootState.user.userMongoID
    ) {
      return true;
    } else {
      return false;
    }
  }
};
